export default class AddRoleRequest {
    roleName:string
}
